import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Button,
  Flex,
  Image,
  Input,
  Space,
  Switch,
  Table,
  Tag,
  Typography,
  message,
} from "antd";
import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db_fire } from "../firebase";
import moment from "moment";
import Loading from "../components/Loading";

const { Text } = Typography;

export default function Delivery() {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);

      const q = query(
        collection(db_fire, "users"),
        where("verified", "==", true)
      );

      const snap = await getDocs(q);

      const list = snap.docs.map((d) => ({
        _id: d.id,
        ...d.data(),
      }));

      setCustomers(list);
    } catch (err) {
      console.error(err);
      message.error("Failed to load customers");
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (record) => {
    setEditingId(record._id);
    setEditData({
      name: record.name,
      phone: record.phone,
      verified: record.verified,
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditData({});
  };

  const saveEdit = async (id) => {
    try {
      await updateDoc(doc(db_fire, "users", id), editData);
      message.success("Customer updated");
      setEditingId(null);
      fetchCustomers();
    } catch (err) {
      console.error(err);
      message.error("Update failed");
    }
  };

  const toggleVerified = async (id, value) => {
    try {
      await updateDoc(doc(db_fire, "users", id), {
        verified: value,
      });

      setCustomers((prev) =>
        prev.map((u) =>
          u._id === id ? { ...u, verified: value } : u
        )
      );

      message.success("Verification updated");
    } catch (err) {
      message.error("Failed to update verification");
    }
  };

  const columns = [
    {
      title: "Aadhar",
      dataIndex: "aadhar",
      render: (_, record) =>
        editingId === record._id ? (
          <>
            <Input
              placeholder="add remark here" 
              value={editData?.remark}
              onChange={(e) =>
                setEditData({ ...editData, remark: e.target.value })
              }
            />
            <Space>
              Remove Aadhar
              <Switch
                size="small"
                checked={editData.aadhar}
                onChange={(v) =>
                  setEditData({ ...editData, aadhar: null })
                }
              />
            </Space>
          </>
        ) : (
          record.aadhar ? <Image src={record?.aadhar} height={100} /> : <Tag color="red">{record.remark}</Tag>
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (_, record) =>
        editingId === record._id ? (
          <Input
            value={editData.name}
            onChange={(e) =>
              setEditData({ ...editData, name: e.target.value })
            }
          />
        ) : (
          <Text strong>{record.name} [{record.role}]</Text>
        ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (_, record) =>
        editingId === record._id ? (
          <Input
            value={editData.phone}
            onChange={(e) =>
              setEditData({ ...editData, phone: e.target.value })
            }
          />
        ) : (
          record.phone || "-"
        ),
    },
    {
      title: "Verified",
      dataIndex: "verified",
      align: "center",
      render: (_, record) =>
        editingId === record._id ? (
          <Switch
            checked={editData.verified}
            onChange={(v) =>
              setEditData({ ...editData, verified: v })
            }
          />
        ) : (
          <Switch
            size="small"
            checked={record.verified}
            onChange={(v) => toggleVerified(record._id, v)}
          />
        ),
    },
    {
      title: "Joined",
      dataIndex: "createdAt",
      render: (v) =>
        v ? moment(v.toDate()).format("DD MMM YYYY") : "-",
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) =>
        editingId === record._id ? (
          <>
            <Button
              icon={<SaveOutlined />}
              type="link"
              onClick={() => saveEdit(record._id)}
            />
            <Button
              icon={<CloseOutlined />}
              type="link"
              danger
              onClick={cancelEdit}
            />
          </>
        ) : (
          <Button
            icon={<EditOutlined />}
            type="link"
            onClick={() => startEdit(record)}
          />
        ),
    },
  ];

  if (loading) return <Loading />;

  return (
    <>

      <Table
        size="small"
        rowKey="_id"
        columns={columns}
        dataSource={customers}
        pagination={{ pageSize: 10 }}
        bordered
        scroll={{ x: 900 }}
      />
    </>
  );
}
